<template lang="pug">
  div
    #tracking
      .tracking-list
        .tracking-item(v-for="(message, index) in caseList", :_id="message._id", v-if="message.event_type == 'message_content' || message.event_type == 'note' || (message.event_type == 'case_message' && message.event && message.event.name != 'read_change')")
          .tracking-icon.status-intransit( @click="showData(message)")
            mic-icon.text-secondary(v-if="message.attachment && message.attachment.type === 'audio'")
            message-circle-icon.text-secondary(v-else-if="message.event_type == 'message_content'")
            tag-icon.text-secondary(v-else-if="message.event_type == 'case_message' && message.event.name == 'tags_change'")
            file-text-icon.text-secondary(v-else-if="message.event_type == 'note' && message.event.name == 'note_added'")
            flag-icon.text-secondary(v-else-if="message.event_type == 'case_message'")
          .tracking-date
            span.text-sm.text-dark {{ showMessageDate(message.date) }}
            span {{ showMessageHour(message.date) }}
          .tracking-content(v-if="message.event_type == 'message_content'")
            .text-sm.text-secondary.mb-3
              hr.change(v-if="message.new_thread == true")
              | Mensaje de {{ message.author ? getMessageAuthorName(message) : '-' }}
              span.message-status(v-if="message.status", :class="getStatusColor(message.status)") {{ getSpanishMessageStatus(message.status) }}
              div
                span.via-msg vía {{ message.platform ? message.platform.capitalize() : '-' }}
                b-badge.hsm_name.mb-1.mr-2.inline-block(v-if="message.hsm_name", variant="info") {{ message.hsm_name }}
              div.referral(v-if="message.referral")       
                span.inline-block Fuente:         
                b-badge.hsm_name.mb-1.mr-2.inline-block( variant="info") {{ message.referral.type }}                
                b-link.inline-block(:href="message.referral.referral_url", target="_blank")                    
                  span.inline-block {{message.referral.title}}  
                  link-icon.icon-sm.ml-2.inline-block
              div(v-if="message.referral && message.referral.media_url")
                b-img.mt-2(:src="message.referral.media_url", height="150px" blank-color="#f2f2f2")
            b-row(no-gutters)
              b-col(cols="auto")
                Avatar.mr-3(size="xxs", :src="userData.profile_pic", :platform="message.platform", v-if="message.author === 'user'")
              b-col(v-viewer="viewer_options")
                b-img.mw-60.mw-md-40(rounded, v-if="message.image", :src="message.image", fluid)
                b-img.mw-60.mw-md-40(rounded, v-if="message.attachment && message.attachment.type == 'image'", :src="message.attachment.url", fluid)
                .overflow-x.scrollable-area(v-if="message.gallery && message.gallery.length", style="white-space:nowrap;")
                  .gallery-item(v-for="(item, index) in message.gallery", :key="index", v-if="item.title || item.subtitle || item.image_url || (item.buttons && item.buttons.length)")
                    .img-container.position-relative(v-if="item.image_url")
                      b-img(:src="item.image_url", :blank="!item.image_url", @error="item.image_url = ''", blank-color="#f2f2f2")
                    .gallery-content
                      .title(v-html="item.title")
                      .subtitle(v-if="item.subtitle", v-html="item.subtitle")
                      b-button.gallery-button(variant="light", v-for="(button, button_index) in item.buttons", :key="button_index", v-html="button.title")
                .mw-60.mw-md-40(v-if="message.location")
                  LocationMessage(v-bind="message.location")
                chat-list-template(v-else-if="message.list && message.list.elements && message.list.elements.length", v-bind="message.list")
                .messenger-text(v-if="message.attachment || message.text", :class="{user: (message.author === 'user' || message.author === 'platform'), 'text-buttons': (message.buttons && message.buttons.length) || (message.attachment && message.attachment.type !== 'audio')}")
                  .textAnswered(v-if="message.wamIDAnswered", @click="goToMessage(message)") {{ findMessageText(message) }}
                  div(v-if="message.attachment && message.attachment.type !== 'audio'")
                    b-link.d-none(:ref="'attachment_link_' + index", :href="message.attachment.url", target="blank")
                    .text {{ getFileName(message.attachment) }}
                    b-button.message-button(variant="outline-primary", @click="$refs['attachment_link_' + index][0].$el.click()") Descargar
                      arrow-down-circle-icon.icon-md.ml-2
                  div(v-if="showAudioFile(message)").d-flex.justify-content-start.align-items-center
                    audio(controls, :src="message.attachment.url", :data-author="message.author")
                  div
                    .text(v-html="message.text")
                    b-button.message-button(variant="light", v-for="(button, index) in message.buttons" :key="index", v-html="button.title")
                .overflow-x.scrollable-area.mt-3(style="white-space:nowrap;", v-if="message.quick_replies && message.quick_replies.length")
                  .quick-reply(v-for="(quick_reply, qr_index) in message.quick_replies", :key="qr_index", v-if="quick_reply.title", v-html="quick_reply.title")
          .tracking-content(styles="padding=0px", v-else-if="message.event_type == 'case_message'")
            .text-sm.text-secondary Acción {{ message.admin_id ? `de ${getMessageAuthorName(message)}` : 'automática' }}
            CaseEvent(:event="message.event", :message="message")
          .tracking-content(v-else-if="message.event_type == 'note'")
            .text-sm.text-secondary Acción {{ message.admin_id ? `de ${getMessageAuthorName(message)}` : 'automática' }}
            CaseEvent(:event="message.event", :message="message")
      empty-message(message="No hay mensajes para mostrar", v-if="!caseList.length && !isAxiosLoading")
      b-modal(v-model="create_user_modal", title="Detalle del mensaje", ok-only, ok-title='Cerrar detalle', ok-variant="secondary")
        message-details(:message_id="selected_message._id")
</template>

<script>
import Avatar from './Avatar.vue'
import ChatListTemplate from './ChatListTemplate'
import LocationMessage from './LocationMessage'
import { EventBus } from '../helpers/eventBus'
import MessageDetails from '../components/MessageDetails'
import { createNamespacedHelpers } from 'vuex'

const accountController = createNamespacedHelpers('account')
const CaseEvent = () => import('./CaseEvent.vue')
const NAME_FILE_NOT_AVAILABLE = 'Nombre de archivo no disponible'

export default {
  data() {
    return {
      create_user_modal: false,
      selected_message: {},
    }
  },
  props: {
    case_messages: {
      type: Array,
      default: function () {
        return []
      }
    },
    viewer_options: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    admins: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  computed: {
    ...accountController.mapGetters(['accountTimezone']),
    caseList() {
      const uniqueMessages = new Set(this.case_messages.map(caseMessage => caseMessage._id));

      return Array.from(uniqueMessages).map(id => {
        return this.case_messages.find(caseMessage => caseMessage._id === id)
      })
    }
  },
  methods: {
    findMessageText(message) {
      const index = this.case_messages.findIndex(({ wamID, external_id }) => {
        return wamID === message.wamIDAnswered || external_id === message.wamIDAnswered
      })

      if (index >= 0) return this.case_messages[index].text
    },
    findMessage(message) {
      const index = this.case_messages.findIndex(({ wamID, external_id }) => {
        return wamID === message.wamIDAnswered || external_id === message.wamIDAnswered
      })

      if (index >= 0) return this.case_messages[index]
    },
    goToMessage(message) {
      const messageFound = this.findMessage(message)

      this.$emit('goToExactMessage', messageFound)
    },
    showAudioFile(message) {
      const { attachment = {} } = message || {}
      const { type } = attachment || {}

      return type === 'audio'
    },
    showData(message) {
      this.create_user_modal = true
      this.selected_message = message
    },
    showMessageDate(date) {
      return this.$moment(date).tz(this.accountTimezone).format('DD-MM-YYYY')
    },
    showMessageHour(date) {
      return this.$moment(date).tz(this.accountTimezone).format('hh:mm A')
    },
    getStatusColor(status) {
      const color = {
        read: 'text-success',
        delivered: 'text-warning',
        failed: 'text-danger',
        sent: 'text-primary',
        warning: 'text-warning',
        deleted: 'text-danger'
      }[status]

      return color
    },
    getSpanishMessageStatus(messageStatus) {
      const status = {
        read: 'Leído',
        delivered: 'Entregado',
        failed: 'Fallido',
        sent: 'Enviado',
        deleted: 'Eliminado',
        warning: 'Advertencia'
      }[messageStatus]

      return status
    },
    getMessageAuthorName (message) {
      if (message.author === 'user') return this.getName(this.userData)
      if (message.author === 'platform') return 'Widget'
      if (message.admin_id) {
        const admin = this.admins.find(admin => admin.admin_id === message.admin_id)

        return (admin) ? this.getName(admin) : 'Administrador'
      }

      return (message.author) ? message.author : ''
    },
    getFileName (file) {
      let field = file.url || file.src

      if (!field) return NAME_FILE_NOT_AVAILABLE

      try {
        return decodeURIComponent(field.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1)[0])
      } catch (e) {
        console.log(e.message)

        return NAME_FILE_NOT_AVAILABLE
      }
    },
    getName(name) {
      const { first_name: firstName, last_name: lastName} = name
      const hasLastName = Boolean(lastName)
      let username = firstName

      if (hasLastName) username += ` ${lastName}`

      return username || 'Usuario'
    }
  },
  mounted() {
    EventBus.$on('message/updated', (newMessage) => {
      const message = this.case_messages.find(caseMessage => caseMessage._id === newMessage._id)

      if (!message) return

      message.status = newMessage.status
    })
  },
  unmounted () {
    EventBus.$off('message/updated')
  },
  components: { CaseEvent, Avatar, ChatListTemplate, MessageDetails, LocationMessage }
}
</script>

<style lang="scss" scoped>
audio::-webkit-media-controls-panel {
  background-color: #f1f0f0;
  border-style: hidden;
}

audio[data-author="user"]::-webkit-media-controls-panel {
  background-color: #0099ff;
  border-style: hidden;
}

audio::-webkit-media-controls-current-time-display {
  font-size: 15px;
}

audio::-webkit-media-controls-time-remaining-display {
  font-size: 15px;
}

audio::-webkit-media-controls-play-button {
  background-color: rgba(183, 206, 255, 1);
  border-radius: 50px;
  padding: 15px;
}

audio::-webkit-media-controls-play-button:hover {
  background-color: #ccdcff;
}
  .text {
    white-space: break-spaces;
  }
  .inline-block {
    display: inline-block !important;
  }
  .via-msg{
    display: inline-flex !important;
  }
  .hsm_name{
    display: inline-flex !important;
    margin-left: 5px;
    color:#fff !important;
  }
  .message-status{
    display: inline-block !important;
    margin-left: 5px;
  }
  .tracking-detail {
   padding:3rem 0;
  }
  #tracking {
   margin-bottom:1rem;
  }
  [class*=tracking-status-] p {
   margin:0;
   font-size:1.1rem;
   color:#fff;
   text-transform:uppercase;
   text-align:center;
  }
  [class*=tracking-status-] {
   padding:1.6rem 0;
  }
  .tracking-status-intransit {
   background-color:#65aee0;
  }
  .tracking-status-outfordelivery {
   background-color:#f5a551;
  }
  .tracking-status-deliveryoffice {
   background-color:#f7dc6f;
  }
  .tracking-status-delivered {
   background-color:#4cbb87;
  }
  .tracking-status-attemptfail {
   background-color:#b789c7;
  }
  .tracking-status-error,.tracking-status-exception {
   background-color:#d26759;
  }
  .tracking-status-expired {
   background-color:#616e7d;
  }
  .tracking-status-pending {
   background-color:#ccc;
  }
  .tracking-status-inforeceived {
   background-color:#214977;
  }

  .tracking-item {
   border-left:1px solid #e5e5e5;
   position:relative;
   padding:2rem 1.5rem .5rem 1.5rem;
   font-size:.9rem;
   margin-left:1.5rem;
   min-height:5rem;
  }
  .tracking-item:last-child {
   margin-bottom: 2rem;
  }
  .tracking-item .tracking-date {
   margin-bottom:.5rem;
  }
  .tracking-item .tracking-date span {
   color:#888;
   font-size:85%;
   padding-left:.4rem;
  }
  .tracking-item .tracking-content {
   padding:.5rem 0;
   border-radius:.5rem;
  }
  .tracking-item .tracking-content span {
   display:block;
   color:#888;
   font-size:85%;
  }

  .referral {
    margin-top: 10px;
  }

  .tracking-item .tracking-icon {
   line-height:2.6rem;
   position:absolute;
   left:-1.3rem;
   width:2.6rem;
   height:2.6rem;
   text-align:center;
   border-radius:50%;
   font-size:1.1rem;
   background-color:#fff;
   color:#fff;
  }
  .tracking-item .tracking-icon.status-sponsored {
   background-color:#f68;
  }
  .tracking-item .tracking-icon.status-delivered {
   background-color:#4cbb87;
  }
  .tracking-item .tracking-icon.status-outfordelivery {
   background-color:#f5a551;
  }
  .tracking-item .tracking-icon.status-deliveryoffice {
   background-color:#f7dc6f;
  }
  .tracking-item .tracking-icon.status-attemptfail {
   background-color:#b789c7;
  }
  .tracking-item .tracking-icon.status-exception {
   background-color:#d26759;
  }
  .tracking-item .tracking-icon.status-inforeceived {
   background-color:#214977;
  }
  .tracking-item .tracking-icon.status-intransit {
   color:#e5e5e5;
  }

.textAnswered {
  background-color: rgba(0,0,0,0.2);
  color: white !important;
  white-space: break-spaces;
  border-radius: 8px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-left: 4px solid #243AE5;
  text-decoration: none !important;
  cursor: pointer;
  margin-top: 6px;
}
  @media(min-width:992px) {
   .tracking-item {
    margin-left:6.5rem;
   }
   .tracking-item .tracking-date {
    position:absolute;
    left:-6.5rem;
    // width:7.5rem;
    text-align:right;
   }
   .tracking-item .tracking-date span {
    display:block;
   }
   .tracking-item .tracking-content {
    padding:0;
    background-color:transparent;
   }
  }

  .change {
    color: #d6d8db;
    border-top: dotted 6px;
  }
</style>
